<template>
  <div style="overflow: hidden">
    <!-- Background image -->

    <CRow class="topCard bg-white">
      <CCol class="mainBackground">
        <!-- Banner -->

        <CRow class="w-100">
          <CCard
            style="
              width: 100%;
              margin: 5rem 2rem auto;
              border: 0;
              background-color: transparent;
            "
          >
            <CCardHeader class="cardheader">
              <p class="topictext">Learning Profile</p>
            </CCardHeader>
            <CCardBody v-if="loadingUserdata">
              <div class="container vertical-center">
                <LoadingMDL />
              </div>
            </CCardBody>
            <CCardBody v-else >
              <CRow>
                <CCol xl="3" lg="3" md="5" sm="8" :style="atbo">
                  <a
                    v-if="
                      this.$store.getters['profile/getProfile'].userinfo
                        .image_profile == undefined
                    "
                    style="font-size: 200px; color: #ccc"
                  >
                    <i class="fa fa-user"></i>
                  </a>
                  <img
                    v-else
                    class="alligator-turtle"
                    :src="
                      this.$store.getters['profile/getProfile'].userinfo
                        .image_profile
                    "
                  />
                </CCol>

                <!-- <CCol id="number" xl="3" lg="4" md="6" sm="8"> -->
                <CCol xl="4" lg="4" md="4" sm="3">
                  <div style="text-align: center; margin-top: 35px" v-if="userProfile.userinfo.userinfo.firstname && userProfile.userinfo.userinfo.lastname">
                    <p
                      class="TopicName"
                      v-if="
                        userProfile.userinfo.userinfo.firstname.length !== 0 &&
                          userProfile.userinfo.userinfo.lastname.length !== 0
                      "
                    >
                      {{ userProfile.userinfo.userinfo.firstname[0].val }}
                      {{ userProfile.userinfo.userinfo.lastname[0].val }}
                    </p>
                    <p class="TopicNumber">{{ cardid }}</p>
                  </div>
                  <div class="boxs w-100 mt-2">
                    <div class="boxcss">
                      <p class="TopicNumber nowrap">Enrolled</p>
                      <b class="Numberinformation">{{
                        tmpEnrolled.length || 0
                      }}</b>
                    </div>
                    <!-- <div class="boxcss">
                      <p class="TopicNumber nowrap">Favourite</p>

                      <b class="Numberinformation">{{
                        userCourse.favourite.length || 0
                      }}</b>
                      <b class="Numberinformation" v-if="userCourse.inprogress.length === null">0</b>
                    </div> -->
                    <div class="boxcss">
                      <p class="TopicNumber nowrap">Completed</p>
                      <b style="color: #44bf9e" class="Numberinformation">{{
                        this.tmpComplete.length || 0
                      }}</b>
                    </div>
                    <div class="boxcss">
                      <p class="TopicNumber nowrap">Unenrolled</p>
                      <b style="color: #bd2531" class="Numberinformation">{{
                        this.tmpUnenrolled.length || 0
                      }}</b>
                    </div>
                  </div>
                </CCol>

                <!-- <CCol xl="5" lg="7" sm="12" md="12">
                  <div style="display: flex; height: 25px">
                    <b class="textViewall2">MY CERTIFICATE</b>
                    <router-link to="/homepage" class="textViewall"
                      >VIEW ALL</router-link
                    >
                  </div>
                  <div class="photo3" id="test">
                    <div v-for="item in testcertificate" :key="item">
                      <img class="imageoverview" :src="item.image">
                    </div>
                    <p class="nodata">No certificate</p>
                  </div>
                </CCol> -->
              </CRow>
            </CCardBody>
          </CCard>
        </CRow>

        <!-- ----------------------------------------------------ENROLLED COURSE---------------------------------------------------- -->

        <div>
          <div class="ml-5 mt-3" v-if="!clickingOnProgress">
            <p class="topictext">Enrolled Course</p>
            <div class="containerDanger" style="height: 22rem">
              <CRow v-if="loadingEnrolledCourse" class="w-100" style="margin-top: 30px">
                  <div class="container">
                    <LoadingMDL />
                  </div>
              </CRow>
              <CRow v-else class="w-100" style="margin-top: 30px">
                <!-- Right Button -->
                <div
                  class="left"
                  @click="swipeLeftFree"
                  v-if="tmpEnrolled.length > 5"
                >
                  <img
                    src="@/assets/icons/navigation/Previous2.svg"
                    style="height: 100%; width: 100%; object-fit: cover"
                  />
                </div>
                <div
                  class="wrapper"
                  id="content-free"
                  ref="contentFree"
                  style="height: auto; overflow-x: auto; width: 98%"
                >
                  <div
                    class="mt-2 ml-2 itemC"
                    v-for="(item, index) in tmpEnrolled"
                    :key="index"
                  >
                  <div v-if="item.enroll" style="margin-left: 30px">
                      <mdlCard
                        :data="item"
                        type="inProgress"
                        :index="index"
                      />
                    </div>
                    <!-- <div v-if="!item.unenroll" style="margin-left: 30px">
                      <mdlCard
                        :data="item"
                        type="inProgress"
                        :index="index"
                        @progressbar="clickingOnProgressEmit"
                      />
                    </div>
                    <div v-if="!item.enroll" style="margin-left: 30px">
                      <mdlCard
                        :data="item"
                        type="inProgress"
                        :index="index"
                        @progressbar="clickingOnProgressEmit"
                      />
                    </div> -->
                  </div>
                  <h1
                    v-if="
                      tmpEnrolled == undefined ||
                        tmpEnrolled == null ||
                        tmpEnrolled.length == 0
                    "
                    class="nodata"
                  >
                    No Course
                  </h1>
                </div>

                <div
                  class="right"
                  @click="swipeRightFree"
                  v-if="tmpEnrolled.length > 5"
                >
                  <img
                    src="@/assets/icons/navigation/Next2.svg"
                    style="height: 100%; width: 100%; object-fit: cover"
                  />
                </div>
              </CRow>
            </div>
          </div>
          <div class="ml-5 mt-3" v-else>
            <CRow>
              <CCol xl="11" lg="6" md="6" sm="6" style="margin-top: 15px">
                <h4 class="topictext">{{ courseName }}</h4>
                <p>Progressing</p>
              </CCol>
              <CCol xl="1" lg="6" md="6" sm="6" style="margin-top: 15px">
                <CButton
                  @click="backToInprogressCourse()"
                  class="btn-overview hover mb-0"
                  >Back</CButton
                >
              </CCol>
            </CRow>
            <br />
            <!-- Right Button -->
            <br />

            <CRow>
              <CCol
                col="1.5"
                v-for="(item, index) in courseDetail"
                :key="index"
              >
                <div class="containerDanger">
                  <div
                    v-if="item.progress != null"
                    class="wrapper"
                    id="content-free"
                    ref="contentFree"
                    style
                  >
                    <div class="itemC">
                      <div style="margin: 10px; margin-top: 45px">
                        <progressCard
                          :index="index + 1"
                          :data="sentData"
                          :progress="item.progress"
                          :courseDetail="item"
                          :link="item.code"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CCol>
            </CRow>
          </div>
        </div>

        <br />
        <!-- ----------------------------------------------------MY Favorite course---------------------------------------------------- -->
        <!-- <div class="ml-5 mt-5">
          <CRow class="w-100">
            <CCol>
              <p class="topictext">My Favorite Course</p>
            </CCol>
          </CRow>
          Right Button
          <div class="containerDanger" style="height: 250px">
            <div class="left" id="left-button-new" @click="swipeLeftNew">
              <img
                src="@/assets/icons/navigation/Previous2.svg"
                style="height: 100%; width: 100%; object-fit: coer"
              />
            </div>
            DisplayCard
            v-if="this.newCourse.length!==undefined"
            <div
              class="wrapper"
              id="content"
              ref="contentGod"
              style="overflow-x: auto; height: auto; width: 97%"
            >
              <div
                class="mt-2 ml-2 itemC"
                v-for="(item, index) in userCourse.favourite"
                :key="index"
              >
                <div style="margin-left: 10px">
                  <mdlCard :data="item" type="favourite" :index="index" />
                </div>
                <p>{{userCourse.favourite[index].courseId.title[0].val}}</p>
              </div>
              <h1
                class="nodata"
                v-if="
                  userCourse.favourite == undefined ||
                    userCourse.favourite == null ||
                    userCourse.favourite.length === 0
                "
              >
                No Course
              </h1>
            </div>
            <div class="right" id="right-button" @click="swipeRightNew">
              <img
                src="@/assets/icons/navigation/Next2.svg"
                style="height: 100%; width: 100%; object-fit: cover"
              />
            </div>
          </div>
        </div> -->
        <br />
        <!-- ----------------------------------------------------MY Complete course---------------------------------------------------- -->
        <!-- <div class="ml-5 mt-5">
          <CRow class="w-100">
            <CCol>
              <p class="topictext">My Complete Course</p>
            </CCol>
          </CRow>
          <div class="containerDanger" style="height: 220px">
            <div class="left mt-140" id="left-button-new" @click="swipeLeftNew">
              <img
                src="@/assets/icons/navigation/Previous2.svg"
                style="height: 100%; width: 100%; object-fit: coer"
              />
            </div>
            <div
              class="wrapper"
              id="content-new"
              ref="contentNew"
              style="overflow-x: auto; height: auto; display: flex"
              v-if="tmpComplete.length > 0"
            >
              <div
                class="itemC"
                v-for="(item, index) in tmpComplete"
                :key="index"
              >
                <div style="margin-left: 10px">
                  <mdlCard :data="item" type="completed" :index="index" />
                </div>
              </div>
            </div>
            <h1
              class="nodata"
              v-if="
                tmpComplete == undefined ||
                  tmpComplete == null ||
                  tmpComplete.length == 0
              "
            >
              No Course
            </h1>
            <div class="right mt-140" id="right-button" @click="swipeRightNew">
              <img
                src="@/assets/icons/navigation/Next2.svg"
                style="height: 100%; width: 100%; object-fit: cover"
              />
            </div>
          </div>
        </div> -->
        <br />
        <!-- ----------------------------------------------------unenrolled course---------------------------------------------------- -->
        <!-- <div class="ml-5 mt-5">
          <CRow class="w-100">
            <CCol>
              <p class="topictext">Unenrolled Course</p>
            </CCol>
          </CRow>
          Right Button
          <div class="containerDanger" style="height: 220px">
            <div class="left" id="left-button-new" @click="swipeLeftNew">
              <img
                src="@/assets/icons/navigation/Previous2.svg"
                style="height: 100%; width: 100%; object-fit: coer"
              />
            </div>
            DisplayCard
        
              <h1
                class="nodata"
                v-if="
                  tmpUnenrolled == undefined ||
                    tmpUnenrolled == null ||
                    tmpUnenrolled.length == 0
                "
              >
                No Course
              </h1>
              <div v-else>
                <div
                  class="itemC"
                  v-for="(item, index) in tmpUnenrolled"
                  :key="index"
                >
                  <mdlCard :data="item" type="completed" :index="index" />
                </div>
              </div>
          
            <div class="right" id="right-button" @click="swipeRightNew">
              <img
                src="@/assets/icons/navigation/Next2.svg"
                style="height: 100%; width: 100%; object-fit: cover"
              />
            </div>
          </div>
        </div> -->
      </CCol>
    </CRow>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import courseCard from "../showSingleCard/CourseCardProgress";
import courseCardSuggest from "../showSingleCard/CourseCardSuggest";
import mdlCard from "../showSingleCard/MdlCard";
//import topicCard from "../showSingleCard/TopicCard";
import progressCard from "../showSingleCard/ProgressCard";
import LoadingMDL from "../../components/loading/LoadingMDL";
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      loadingUserdata: true,
      loadingEnrolledCourse: true,
      loadingFavCourse: true,
      width: 0,
      CheckWidth: 0,
      CheckWidthCard: null,
      cardItem: [],
      interval: 6000,
      course: "",
      newCourse: "",
      userProfile: [],
      certificateList: [],
      userCourse: [],
      Suggest: [],
      codeID: "",
      suggestCourse: null,
      tmpComplete: [],
      tmpEnrolled: [],
      tmpUnenrolled: [],
      clickingOnProgress: false,
      courseCodeIdParams: "",
      courseName: "Course Name",
      sentData: {
        status: true,
      },
      cardid: "",
      atbo: "",
      courseDetail: [],
      courseProgress: [],
      imageProfile: "",
    };
  },
  components: {
    progressCard,
    courseCard,
    courseCardSuggest,
    mdlCard,
    LoadingMDL,
  },
  computed: {
    ...mapGetters({
      getFreeCourse: "courses/getFreeCourses",
      userProfileGetter: "userProfileGetter",
      userCourseGetter: "userCourseGetter",
      getCourseChapterAndProgress: "courses/getCourseChapterAndProgress",
      v3UserEnrollCourse: "v3-data/v3UserEnrollCourse"
    }),
  },
  watch: {
    v3UserEnrollCourse: function(val) {
      console.log('v3UserEnrollCourse v3UserEnrollCourse', val);
      //
      this.userCourse = val;
      this.tmpComplete = []
      this.tmpEnrolled = []
      this.tmpUnenrolled = []
      // this.suggestCourse = this.userCourse.suggest;
      this.v3GetEnrolled(this.userCourse);
      // this.getComplete(this.userCourse.enrolls);
      // this.getEnrolled(this.userCourse.enrolls);
      // this.getUnenrolled(this.userCourse.enrolls);
    },
    userCourseGetter: function(val) {
      this.userCourse = val;
      this.tmpComplete = []
      this.tmpEnrolled = []
      this.tmpUnenrolled = []
      // this.suggestCourse = this.userCourse.suggest;
      this.v3GetEnrolled(this.userCourse);
      // this.getComplete(this.userCourse.enrolls);
      // this.getEnrolled(this.userCourse.enrolls);
      // this.getUnenrolled(this.userCourse.enrolls);
    },
    userProfileGetter: function(val) {
      this.userProfile = val;
      if (this.userProfile.userinfo.userinfo.card_id == null) {
        this.cardid = "";
      } else {
        this.cardid = this.userProfile.userinfo.userinfo.card_id;
      }
      this.loadingUserdata = false;
    },
    courseCodeIdParams: function() {},
    getCourseChapterAndProgress: function(val) {
      this.courseDetail = val.template;
    },
  },
  mounted() {
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("auth/fetchCourseEducation");
      // this.$store.dispatch("v3-data/v3UserEnrollCourse"); ////
    }
    // if (this.$store.getters["courses/getCourseCodeandInProgressStatus"].length != 0) {
    //   this.courseCodeIdParams = this.$store.getters["courses/getCourseCodeandInProgressStatus"].courseCodeParams;
    //   this.clickingOnProgress = this.$store.getters["courses/getCourseCodeandInProgressStatus"].progressStatus;
    //   this.courseName = this.$store.getters["courses/getCourseCodeandInProgressStatus"].courseName;
    //   this.$store.dispatch("courses/fetchCourseChapterAndProgress",this.courseCodeIdParams);
    // }
    
  },
  created() {
    this.onLoadUserInfo();
    this.CheckWidth = window.innerWidth;
    this.checkwidth();
    window.addEventListener("resize", this.checkwidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkwidth);
  },
  beforeDestroy() {},
  methods: {
    checkwidth() {
      this.width = window.innerWidth;
      if (this.width <= 425) {
        this.atbo = "justify-content:center;display: flex;";
      } else {
        this.atbo = "";
      }
    },

    onLoadUserInfo() {
      this.$store.dispatch("fetchUserDataByToken");
    },
    clickingOnProgressEmit(val) {
      this.clickingOnProgress = val[0];
      this.courseCodeIdParams = val[1];
      this.courseName = val[2];
      this.$store.dispatch("courses/fetchCourseChapterAndProgress",this.courseCodeIdParams);
    },
    backToInprogressCourse() {
      this.clickingOnProgress = false;
    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      if (!((scrollPos === 0 || scrollPixels > 0) &&(element.clientWidth + scrollPos === element.scrollWidth ||scrollPixels < 0))) {
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }

        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },
    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftNew() {
      const content = this.$refs.contentNew;
      this.scrollTo(content, -300, 800);
    },
    swipeRightNew() {
      const content = this.$refs.contentNew;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, -300, 800);
    },
    swipeRightFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftGod() {
      const content = this.$refs.contentGod;
      this.scrollTo(content, -300, 800);
    },
    swipeRightGod() {
      const content = this.$refs.contentGod;
      this.scrollTo(content, 300, 800);
    },
    v3GetEnrolled(obj) {
      this.tmpEnrolled = [];

      obj.forEach((item) => {
        if (item.enroll) {
          item._id = item.courseinfo._id
          item.code = item.courseinfo.code
          item.controls = item.courseinfo.controls
          item.style = item.courseinfo.style
          delete item.courseinfo

          console.log('v3GetEnrolled', item);
          this.tmpEnrolled.push(item);
        }
      });
      this.loadingEnrolledCourse = false
    },
    getEnrolled(obj) {
      this.tmpEnrolled = [];

      obj.forEach((item) => {
        if (!item.unenroll && !item.complete) {
          this.tmpEnrolled.push(item);
        }
      });
      this.loadingEnrolledCourse = false
    },
    getUnenrolled(obj) {
      console.log('getUnenrolled', obj);
      
      this.tmpUnenrolled = [];
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].unenroll == true) {
          this.tmpUnenrolled.push(item);
        }
      }
    },
    getComplete(obj) {
      this.tmpComplete = [];
      obj.forEach((item) => {
        if (item.complete) {
          this.tmpComplete.push(item);
        }
      });
    },
    // bannerNav(navigation) {
    //   alert("Go to: " + navigation);
    // },
    // setCardWidth(value) {
    //   let items = document.getElementsByClassName(value);
    //   let item = items[0];
    //   let itemWidth = items[0].getBoundingClientRect();
    // },
  },
};
</script>

<style scoped>
#text-nocert {
  font-size: 2rem;
}
.mainBackground {
  overflow: hidden;
  background-image: url("../../assets/icons/bg_learning.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.viewAllText:hover {
  cursor: pointer;
}

/* container for store cards */
.containerDanger {
  position: relative;
  width: 100%;
  height: auto;
}

.containerDanger .wrapper {
  float: left;
  width: 100%;
  height: 100%;
  margin: 1px;
  overflow: hidden;
  white-space: nowrap;
  background: transparent;
  /* display: flex; */
}
.mt-150 {
  margin-top: 150px !important;
}
.containerDanger .wrapper .viewAllIconContainer {
  text-align: center;
  height: 220px;
  line-height: 220px;
}

.containerDanger .wrapper .viewAllIconContainer img {
  vertical-align: middle;
}

.containerDanger .wrapper .viewAllIconContainer:hover {
  cursor: pointer;
}

.containerDanger .wrapper::-webkit-scrollbar {
  display: none;
}

.containerDanger .wrapper .itemC {
  height: 100%;
  bottom: 0;
  display: inline-block;
  margin-right: -10px;
}

.containerDanger .left {
  top: 50%;
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 0;
  width: 3%;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDanger .right {
  top: 50%;
  margin-right: 40px;
  text-align: center;
  z-index: 1;
  position: absolute;
  right: 0;
  width: 3%;
  background: black;
  color: white;
  opacity: 0.2;
}

.containerDanger .left:hover,
.containerDanger .right:hover {
  cursor: pointer;
  opacity: 0.6;
  background: grey;
}

.carousel.carousel-fade .carousel-item {
  transition: opacity linear 0.6s;
}

.carousel-fade .carousel-item .imgContainer {
  max-height: 70vh;
}

.carousel-fade .carousel-item .imgContainer img {
  width: 100%;
  height: 70vh;
}

.Numberinformation {
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.textViewall {
  margin-left: auto;
  margin-right: 30px;
  font: Bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-top: 4px;
}
.textViewall2 {
  font: Bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-top: 4px;
}
/* -- ----------------------------------------------------------CSS Copy-------------------------------------------------- -- */

.content {
  margin-top: auto;
  margin-bottom: auto;
}

.photo3 {
  width: 100%;
  height: 205px;
  overflow-x: scroll;
  display: flex;
}
.imageoverview {
  width: 240px;
  height: 180px;
  background: transparent;
  box-shadow: 5px 5px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  margin-right: 10px;
}
.boxs {
  display: flex;
  width: 300px;
  height: 100px;
  justify-content: center;
}
.boxcss {
  width: 110px;
  height: 60px;
  border: 1px solid white;
  margin-left: 15px;
  font-size: 14px;
  text-align: center;
  background-color: white;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 5px #00000029;
  border-radius: 10px;
  opacity: 1;
  margin: 5px;
}

/* ---------------------------------------------------CSS scrollbar---------------------------------------------------------------------  */

/* width */
::-webkit-scrollbar {
  height: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #959595;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #959595;
}

#test\::-webkit-scrollbar-thumb {
  background: red;
}
/* ---------------------------------------------------CSS scrollbar---------------------------------------------------------------------  */

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}
.cardheader {
  background-color: transparent;
  border: 0px;
  margin-left: 12px;
}
.btn-overview {
  margin-bottom: 5em;
  font-weight: bold;
  font-size: 16px;
  background-color: #ffbb00;
}

.btn-overview:hover {
  color: white !important;
  background-color: #ffbb00;
}
.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}
.card-body {
  padding: 0px;
  width: 100%;
  box-shadow: 0px 0px 30px #00000029;
  border-radius: 20px;
  opacity: 1;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  margin-left: 30px;
}
/* ------------------------------------------------------- VILL all next page ------------------------------------------------------ */

/* background border */
.sign-in-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.sign-in-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.sign-up-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.sign-up-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.text-wrapper {
  position: relative;
  color: #000000;
  width: 100%;
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  font-family: "Roboto", Medium;
}

#app .container.button button {
  color: red !important;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

#info-block section {
  border-top: 1px solid white;
  text-align: center;
}

.file-marker > div {
  padding: 0 3px;
  margin-top: -0.9em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

a {
  text-decoration: none;
}

.nav-link {
  border: none;
}

.nav-tabs {
  border: none;
}

/* -------------------------------------------------------------- modal new --------------------------------------------------------- */
.alligator-turtle {
  object-fit: cover;
  width: 225px;
  height: 235px;
  box-shadow: 5px 5px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
}

.topictext {
  /* padding-left: 0.35rem; */
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
}
/* --------------------------------------------------------------------NEW CSS-------------------------------------------------------------------- */
.topCard {
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  border-color: #cccccc;
  overflow: hidden;
}

.TopicName {
  /* text-align: left; */
  font-size: 24px;
  font: Medium 24px/32px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-size: 24px;
  margin-bottom: 0px;
}
.TopicNumber {
  margin-bottom: 0px;
  font: Regular 16px/21px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.nodata {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  opacity: 0.4;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .nodata {
    left: 40%;
  }
  .textViewall2 {
    margin-left: 20px;
  }
  .card-body {
    margin-left: 15px;
  }
  .boxcss {
    box-shadow: 2px 5px 5px #00000029;
  }
}
</style>
